export default __webpack_public_path__ + "static/media/icon-img-2.d93db8ad.webp";